import { computed, type ComputedRef } from 'vue'

/** The tracker reads each key at send time, so every key of a page's event context is its own computed. */
export function eachKeyComputed<T extends Record<string, unknown>>(source: ComputedRef<T>) {
  return Object.fromEntries(Object.keys(source.value).map((key) => [key, computed(() => source.value[key])]))
}
